import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: { default: ["en-GB"], en: ["en-GB"] },
    supportedLngs: ["en", "en-GB", "en-US", "ja"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",

    debug: process.env.NODE_ENV === "development",

    // IMPORTANT: make your default namespace match what you actually have
    ns: ["common"],
    defaultNS: "common",
    fallbackNS: "common",

    interpolation: { escapeValue: false },
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
  });

export default i18n; // ⇠ just importing this file runs init()
